import { AppSettings } from '@obo-main/utils/appSettings.service';

/**
 * Factory to setup the appsettingsservice
 * @param appSettings
 */
export function AppSettingsFactory(appSettings: AppSettings): Promise<any> {
    return appSettings.loadSettings();
}
